import { render, staticRenderFns } from "./c-manage-pharmacists-add-edit.vue?vue&type=template&id=14255514&scoped=true&"
import script from "./c-manage-pharmacists-add-edit.vue?vue&type=script&lang=js&"
export * from "./c-manage-pharmacists-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./c-manage-pharmacists-add-edit.vue?vue&type=style&index=0&id=14255514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14255514",
  null
  
)

export default component.exports